
import { useId } from "react";
import "../styles/MainInput.css";

const MainInput = ({
  label,
  type = "text",
  as = "input",
  value,
  onChange,
  options = [],
  required = true,
  name,
  listId,
  listOptions = [],
  ...rest
}) => {
  const generatedId = useId();
  const fieldId = name || generatedId;

  return (
    <div className="input-group">
      {as === "select" ? (
        <select
          id={fieldId}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          required={required}
          {...rest}
        >
          <option value="" disabled hidden></option>
          {options.map((opt) => {
            const optionValue = typeof opt === "string" ? opt : opt.value;
            const optionLabel = typeof opt === "string" ? opt : opt.label;
            return (
              <option key={optionValue} value={optionValue}>
                {optionLabel}
              </option>
            );
          })}
        </select>
      ) : (
        <>
          <input
            id={fieldId}
            name={name}
            type={type}
            value={value ?? ""}
            onChange={onChange}
            required={required}
            list={listId}
            {...rest}
          />
          {listId && listOptions.length > 0 && (
            <datalist id={listId}>
              {listOptions.map((opt) => (
                <option key={opt} value={opt} />
              ))}
            </datalist>
          )}
        </>
      )}
      <label htmlFor={fieldId}>{label}</label>
    </div>
  );
};

export default MainInput;
